export default "__VITE_ASSET__0UP99f5o__"